// we will leave this enum since here we have 'successWithWarnings' (status is 'SUCCESS' but has warning message)
export enum AssessmentsEnum {
  running = 'RUNNING',
  failed = 'FAILED',
  success = 'SUCCESS',
  pending = 'PENDING',
  notStarted = 'NOT_STARTED',
  successWithErrors = 'SUCCESS_WITH_ERRORS',
  successWithWarnings = 'SUCCESS_WITH_WARNINGS',
}
